import React from 'react'
import { AddButton } from '@e3dc-react/shell/Elements/Buttons'
import { Stack, Grid, IconButton, Typography, useTheme, useMediaQuery } from '@mui/material'
import { FieldArray, useFormikContext } from 'formik'
import { makeStyles } from 'tss-react/mui'
import EMobilityWallboxChargeTariffsDatePicker from './EMobilityWallboxChargeTariffsDatePicker'
import EMobilityWallboxChargeTariffsTextField from './EMobilityWallboxChargeTariffsTextField'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import CloseIcon from '@mui/icons-material/Close'
import { WallboxTariffsFormData } from '../EMobilityWallboxTariffsEditor'

const useStyles = makeStyles()(theme => ({
  inputContainer: {
    backgroundColor: theme.palette.shades.shade04,
    padding: theme.spacing(4),
    borderRadius: theme.shape.borderRadius,
  },
}))

/**
 * Field array for inputs for charge prices.
 * It hols complete array of date pickers and text fields.
 * No param requires.
 * @return JSX element
 */
const EMobilityWallboxChargeTariffsFieldArray = (): JSX.Element => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const { values } = useFormikContext<WallboxTariffsFormData>()
  const { breakpoints } = useTheme()
  const downSm = useMediaQuery(breakpoints.down('sm'))

  return (
    <FieldArray name="chargePrices">
      {({ push, remove }) => {
        return (
          <Stack>
            <Stack flexDirection={downSm ? 'column' : 'row'} justifyContent={'space-between'} alignItems={'center'} mb={2} mt={5}>
              <Typography>{t('emobility.wallbox.editTariffs.chargePrice')}</Typography>
              <AddButton
                buttonProps={{ color: 'success' }}
                onClick={() => push({ validFrom: new Date().toDateString(), price: 0 })}
                label={t('emobility.wallbox.editTariffs.addChargePricing')}
              />
            </Stack>
            <Stack spacing={3}>
              {values.chargePrices.map((price, index: number) => (
                <Stack className={classes.inputContainer} key={index}>
                  <Grid container columns={13} spacing={4} alignItems={'center'}>
                    <Grid item xs={12} sm={6}>
                      <EMobilityWallboxChargeTariffsDatePicker validFrom={price.validFrom} index={index} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <EMobilityWallboxChargeTariffsTextField price={price.price} index={index} />
                    </Grid>
                    <Grid item xs={1}>
                      <IconButton onClick={() => remove(index)}>
                        <CloseIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Stack>
              ))}
            </Stack>
          </Stack>
        )
      }}
    </FieldArray>
  )
}

export default EMobilityWallboxChargeTariffsFieldArray
